import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const useChannels = (page = 1, limit = 100, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["channels", page, limit, search],
    () =>
      fetchData(
        `/channels?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
      ),
    {
      // Catálogo muda pouco; cache maior evita refetchs duplicados no boot
      staleTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        channels: response.data || [],
        pagination: response.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (channel) => {
      const method = channel.id ? "PUT" : "POST";
      const endpoint = channel.id ? `/channels/${channel.id}` : `/channels`;
      return fetchData(endpoint, method, channel);
    },
    {
      onSuccess: () => queryClient.invalidateQueries("channels"),
    }
  );

  const deleteMutation = useMutation(
    (id) =>
      fetchData(`/channels/${id}`, "DELETE"),
    {
      onSuccess: () => queryClient.invalidateQueries("channels"),
    }
  );

  return { ...query, updateMutation, deleteMutation };
};
